import React, {Component} from 'react';
import { Flex, MyCampo, Mycard, Transition} from "../ui";
import {Btn} from "./../UI-Components/Btn";
import {css} from "@emotion/core";
import SimpleReactValidator from 'simple-react-validator';
import {serviceApiResponse} from "../ServiciosMaestros/request";
import {api} from "../ServiciosMaestros/apis";
import { handleIntegrationError } from "../ServiciosMaestros/handleIntegrationError";
import { sanitizeBackendMessage } from "../ServiciosMaestros/integrationErrors";
import { Modal2 } from "../ServiciosMaestros/componentGeneral";
import { DescriptionComponent } from '../Helpers/urlDescription'

const Campos = ({conf, i, onChange, disabled, onChangeRadio, onChangeCheckbox, onChangePrefijo, onChangeValor, error, onChangeDate, handleDateChangeTime, onChangeValor2}) => {
    if (conf.fieldType === "select") {
        return (
            <MyCampo
                disabled={disabled}
                select
                label={conf.name}
                options={conf.fieldOptions}
                value={conf.value}
                name={i}
                onchange={onChange.bind(this)}
                obligatory={conf.obligatory}
                error={error}
                help={conf.help}
            />
        )
    }
    else if (conf.fieldType === "password") {
        return (
            <MyCampo
                disabled={disabled}
                type="password"
                label={conf.name}
                placeholder={conf.name}
                value={conf.value}
                configuracionCampos={conf.fieldTypes}
                name={i}
                onchange={onChange.bind(this)}
                obligatory={conf.obligatory}
                error={error}
                help={conf.help}
            />
        )
    }
    else if (conf.fieldType === "text") {
        return (
            <MyCampo
                disabled={disabled}
                type="text"
                label={conf.name}
                placeholder={conf.name}
                value={conf.value}
                configuracionCampos={conf.fieldTypes}
                name={i}
                onchange={onChange.bind(this)}
                obligatory={conf.obligatory}
                error={error}
                help={conf.help}
            />
        )
    }
    else if ((conf.fieldType === "number" || conf.fieldType === "numeric")) {
        return (
            <MyCampo
                disabled={disabled}
                type="tel"
                label={conf.name}
                placeholder={conf.name}
                value={conf.value}
                name={i}
                onchange={onChange.bind(this)}
                obligatory={conf.obligatory}
                configuracionCampos={conf.fieldTypes}
                error={error}
                help={conf.help}
            />
        )
    }
    else if (conf.fieldType === "date") {
        return (
            <MyCampo
                disabled={disabled}
                type="date"
                label={conf.name}
                placeholder={conf.name}
                value={conf.value}
                name={i}
                onChangeDate={onChangeDate.bind(this)}
                obligatory={conf.obligatory}
                error={error}
                help={conf.help}
            />
        )
    } else if (conf.fieldType === "time") {
        return (
            <MyCampo
                disabled={disabled}
                type="time"
                label={conf.name}
                placeholder={conf.name}
                value={conf.value}
                name={i}
                handleDateChangeTime={handleDateChangeTime.bind(this)}
                obligatory={conf.obligatory}
                error={error}
                help={conf.help}
            />
        )
    } else if (conf.fieldType === "radio" || conf.fieldType === "checkbox") {
        return (
            <MyCampo
                disabled={disabled}
                type={conf.fieldType}
                label={conf.name}
                placeholder={conf.name}
                value={conf.value}
                options={conf.fieldOptions}
                name={i}
                entity={conf.entity}
                onchange={conf.fieldType === "radio" ? onChangeRadio.bind(this) : onChangeCheckbox.bind(this)}
                obligatory={conf.obligatory}
                help={conf.help}
                error={error}
            />
        )
    } else if (conf.fieldType === "textarea") {
        return (
            <MyCampo
                disabled={disabled}
                type="textarea"
                label={conf.name}
                placeholder={conf.name}
                value={conf.value}
                name={i}
                onchange={onChange.bind(this)}
                obligatory={conf.obligatory}
                configuracionCampos={conf.fieldTypes}
                error={error}
                help={conf.help}
            />
        )
    } else if (conf.fieldType === "telephone" || (typeof conf.fieldType === 'object' && conf.fieldType[0].value === "telephone")) {
        return (
            <MyCampo
                disabled={disabled}
                type="telephone"
                label={conf.name}
                placeholder={conf.name}
                value={conf.value}
                valuePrefijo={conf.valuePrefijo ? conf.valuePrefijo : ""}
                name={i}
                onchange={onChange.bind(this)}
                onchangePrefijo={onChangePrefijo.bind(this)}
                obligatory={conf.obligatory}
                viewPrefijo={false}
                error={error}
                help={conf.help}
            />
        )
    } else if (conf.fieldType === "email") {
        return (
            <MyCampo
                disabled={disabled}
                type="email"
                label={conf.name}
                placeholder={conf.name}
                value={conf.value}
                configuracionCampos={conf.fieldTypes}
                name={i}
                onchange={onChange.bind(this)}
                obligatory={conf.obligatory}
                error={error}
                help={conf.help}
            />
        )
    } else {
        return ""
    }
};

let ruta = {};

class InicioOnline extends Component {


    constructor(props) {
        super(props);

        this.validator = new SimpleReactValidator({
            messages: {
                required: "El campo es requerido.",
                between: "El valor mínimo debe ser :min y máximo :max pesos.",
                numeric: "El campo debe ser numérico.",
                min: "El campo debe contener mínimo :min caracteres.",
                max: "El campo debe contener máximo :max caracteres.",
                regex: "Debe ingresar una dirección de correo válida.",
            },
        });
        this.modalRestHorarios = this.modalRestHorarios.bind(this);
    }

    state = {
        configuracion: [],
        titulo: "",
        descripcion: "",
        topes: {
            "min": 5000,
            "max": 200000
        },
        openModal: false
    };

    componentWillMount() {
        ruta = JSON.parse(sessionStorage.getItem("rutas"));
        if(!this.props.rest_horarios.activo){
            this.modalRestHorarios();
        }
    }
    componentDidUpdate(prevProps){
        if(prevProps.rest_horarios.activo!== this.props.rest_horarios.activo){
            if(!this.props.rest_horarios.activo){
                this.modalRestHorarios();
            }
        }
    }
    componentDidMount() {
        let fecha = ``;
        if (sessionStorage.getItem("configuracion")) {
            let confi = JSON.parse(sessionStorage.getItem("configuracion"));
            let configuracionFormulario = JSON.parse(sessionStorage.getItem("detalleFormulario"));
            let titulo = sessionStorage.getItem("titulo");
            let descripcion = sessionStorage.getItem("descripcion");
            if (configuracionFormulario) {
                this.setState({
                    configuracion: configuracionFormulario,
                    titulo,
                    descripcion
                });
            } else if (Object.keys(confi).indexOf("busqueda") !== -1) {
                let configuracion = confi.busqueda.map((conf) => {

                    return {
                        name: conf.tituloCampo,
                        help: conf.textoAyuda,
                        fieldDb: conf.campoDb,
                        obligatory: conf.obligatorio,
                        fieldType: conf.configCampo,
                        fieldOptions: conf.options,
                        fieldOption: conf.haveOptions,
                        fieldTypes: conf.configCampos,
                        entity: conf.tipoCampo,
                        value: conf.configCampo === "time" || conf.configCampo === "date" ? fecha : "",
                        nameParameter: conf.nombreParametro,
                    };
                });

                this.setState({
                    configuracion,
                    titulo,
                    descripcion,
                    topes: confi.topes
                });

            }

        }
    }

    componentWillReceiveProps(nextProps, nextContext) {

        let fecha = ``;
        let configuracionFormulario = JSON.parse(sessionStorage.getItem("detalleFormulario"));
        let titulo = sessionStorage.getItem("titulo");
        let descripcion = sessionStorage.getItem("descripcion");
        let configuracion = JSON.parse(sessionStorage.getItem("configuracion"));
        if (configuracionFormulario) {
            this.setState({
                configuracion: configuracionFormulario,
                titulo,
                descripcion,
                topes: configuracion.topes
            });
        } else if (Object.keys(nextProps).length > 0 && nextProps.configuracion) {
            let Configuracion = nextProps.configuracion.map((conf) => {
                return {
                    name: conf.tituloCampo,
                    help: conf.textoAyuda,
                    fieldDb: conf.campoDb,
                    obligatory: conf.obligatorio,
                    fieldType: conf.configCampo,
                    fieldOptions: conf.options,
                    fieldOption: conf.configCampo,
                    fieldTypes: conf.configCampos,
                    entity: conf.tipoCampo,
                    value: conf.configCampo === "time" || conf.configCampo === "date" ? fecha : "",
                    nameParameter: conf.nombreParametro,

                };
            });

            this.setState({
                Configuracion,
                titulo: nextProps.titulo,
                descripcion: nextProps.descripcion,
                topes: nextProps.topes
            });

        }
    }

    onChange(e) {
        let target = e.target;
        let name = target.name;
        let value = target.value;
        let configuracion = [...this.state.configuracion];
        let campo = configuracion[name];
        campo["value"] = value;
        if (target.id === "telephone") {
            if (value !== "") {
                campo["obligatory"] = true;
                this.forceUpdate();
            } else {
                campo["obligatory"] = false;
                this.forceUpdate();
            }
        }

        configuracion[name] = campo;


        this.setState({
            configuracion
        })
    }

    onChangeRadioButton(e) {
        let target = e.target;
        let name = target.name;
        let value = target.value;

        let configuracion = [...this.state.configuracion];
        let campo = configuracion[name];
        campo["value"] = value;
        configuracion[name] = campo;

        this.setState({
            configuracion
        })
    }

    onChangeCheckbox(e) {
        let target = e.target;
        let name = target.name;
        let value = target.value;
        let check = target.checked;
        let configuracion = [...this.state.configuracion];
        let campo = configuracion[name];
        if (campo["value"] !== "") {
            if (check) {
                campo["value"].push(value);
            } else {
                let newCampo = [];
                newCampo = campo["value"].filter((c) => {
                    return c !== value;
                });
                campo["value"] = newCampo.length > 0 ? newCampo : "";
            }
        } else {
            campo["value"] = [value];
        }
        configuracion[name] = campo;

        this.setState({
            configuracion
        })
    }

    onChangePrefijo(e) {
        let target = e.target;
        let name = target.name;
        let value = target.value;

        let configuracion = [...this.state.configuracion];
        let campo = configuracion[name];
        campo["valuePrefijo"] = value;
        configuracion[name] = campo;

        this.setState({
            configuracion
        })
    }
    modalRestHorarios(){
        this.setState({openModal: true})
    }
    sendInfo() {
        this.setState({
            loading: true
        });
        let configuracion = [...this.state.configuracion];
        let telefono;
        let select="";
        let selectObligatory=false;
        configuracion.map((conf) => {
            if (conf.fieldType === "telephone") return telefono = conf.value;
            if (conf.fieldType === "select"){
                select = conf.value;
                selectObligatory= conf.obligatory;
                return ''
            }else if (conf.obligatory && (!conf.value || conf.value == "")){
                this.validator.fields[""] = false;
                this.validator.errorMessages[""] = "El campo es requerido.";
                return ''
            }
            return ''
        });


        if (telefono && telefono !== "" && (telefono.length < 8 || telefono.length > 10)) this.validator.fields["telefono"] = false;

        if ((typeof select ==="string" && select ==="") && selectObligatory) {
            this.validator.fields[""] = false;
            this.validator.errorMessages[""] = "El campo es requerido.";
        }
        if (this.validator.allValid()) {
            serviceApiResponse({}, api.validarPlan, "POST")
                .then(response => {
                    if (response.success) {

                        sessionStorage.removeItem("isSuscrito");
                        sessionStorage.removeItem("parameterSearch");
                        sessionStorage.removeItem("total");
                        sessionStorage.removeItem("facturas");
                        sessionStorage.removeItem("paginacion");
                        sessionStorage.removeItem("facturaPagar");
                        sessionStorage.removeItem("autoCheckout");

                        this.consultarFactura();
                    } else {
                        this.setState({
                            loading: false
                        });
                        let informacion = JSON.parse(sessionStorage.getItem("informacion"));
                        this.props.openModal(`El servicio se encuentra temporalmente suspendido, lo invitamos a contactar con la ${informacion.nombreEmpresa} para obtener mayor información al (${informacion.tipoTelefonoValue === "fijo" ? informacion.valueIndicativo : informacion.indicativoPais}) ${informacion.tel_empresa} o correo electrónico ${informacion.correo_empresa}.`, "info");
                    }
                })
                .catch(error => {
                    handleIntegrationError(error, {
                        openModal: this.props.openModal,
                        flow: "consulta",
                        service: "recaudo-api",
                        endpoint: api.validarPlan,
                        setState: (updates) => this.setState(updates),
                        stateUpdates: { loading: false },
                        modalType: "warning",
                    });
                });

        } else {
            this.setState({
                loading: false
            });
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    consultarFactura(propConsulta = null,openCheckout = false) { 
        let consulta = null;
        if(!propConsulta){
            consulta = this.state.configuracion.map((conf) => {
                return {
                    parametro: conf.nameParameter,
                    value: conf.value,
                }
            });
        }else{
            consulta = propConsulta;
        }
        let informacion = JSON.parse(sessionStorage.getItem("informacion"));
        serviceApiResponse({consulta}, api.facturasApi, "POST")
            .then(response => {
                const getTipoMoneda = (moneda) => {
                    let tipoMoneda = moneda;
                    if(tipoMoneda){
                        tipoMoneda = tipoMoneda ? tipoMoneda.value : 'COP'
                    }else{
                        tipoMoneda = 'COP'
                    }
                    return tipoMoneda ? tipoMoneda : 'COP';
                }
                    if (response.success) {
                        // console.log("RESPONSE:::", response)
                        if (response.data.facturas.length > 0) {
                            if (response.data.facturas.length === 1)
                                sessionStorage.setItem("facturaPagar", 0);
                            sessionStorage.setItem(
                                "facturas",
                                JSON.stringify(response.data.facturas.map(el=> { return {...el, moneda: getTipoMoneda(response.data.opcionesRecaudo.moneda)}}))
                            );
                            sessionStorage.setItem(
                                "configCampos",
                                JSON.stringify(response.data.configCampos)
                            );
                            sessionStorage.setItem(
                                "total",
                                JSON.stringify(response.data.total)
                            );
                            sessionStorage.setItem(
                                "param",
                                JSON.stringify({
                                    parametro: "Pagos Online",
                                    value: ``,
                                    referencia:`Pagos Online`,
                                    consulta
                                })
                            );
                            sessionStorage.setItem(
                                "log",
                                JSON.stringify(
                                    response.data.log
                                )
                            );
                            if (sessionStorage.getItem("check")) {
                                sessionStorage.removeItem("check");
                                sessionStorage.removeItem("checksOtroValor");
                                sessionStorage.removeItem("checksValor1");
                                sessionStorage.removeItem("checksValor2");
                                sessionStorage.removeItem("checksValor3");
                                sessionStorage.removeItem("valuesOtroValor");
                            }
                            let opcionesRecaudo = response.data.opcionesRecaudo;
                            if (opcionesRecaudo) {
                                sessionStorage.setItem(
                                    "opcionesRecaudo",
                                    JSON.stringify({
                                        ...response.data.opcionesRecaudo, moneda: {
                                        value: getTipoMoneda(response.data.opcionesRecaudo.moneda)
                                    }})
                                );
                            }
                            if (response.data.parametrosConsultaSuscripcion) {
                                sessionStorage.setItem(
                                    "parameterSearch",
                                    JSON.stringify(
                                        response.data.parametrosConsultaSuscripcion
                                    )
                                );
                            }
                            // console.log("RESPONSE DATA::::", response.data);
                            const Ruta = JSON.parse(sessionStorage.getItem("rutas"));
                            if (response.data.facturas.length === 1) { 
                                sessionStorage.setItem("autoCheckout", openCheckout); 
                                this.props.history.push({ pathname: Ruta.factura, isSuscrito: response.data.isSuscrito }); 
                            } 
                            else 
                                this.props.history.push({ pathname: Ruta.facturas, isSuscrito: response.data.isSuscrito });
                        } else {
                            if (Object.keys(response.data).indexOf("producto") >= 0) {
                                if(!response.data.producto) this.props.openModal(`El servicio se encuentra temporalmente suspendido, lo invitamos a contactar con la ${informacion.nombreEmpresa} para obtener mayor información al (${informacion.tipoTelefonoValue==="fijo"?informacion.valueIndicativo:informacion.indicativoPais}) ${informacion.tel_empresa} o correo electrónico ${informacion.correo_empresa}.`, "info");
                                else this.props.openModal(sanitizeBackendMessage(response.text_response) || "Ocurrió un error al consultar la factura, por favor intente más tarde", "info");
                            } else {
                                if(response.text_response === "facturas"){
                                    this.props.openModal("Ocurrió un error al consultar la factura, por favor intente más tarde", "warning");
                                }else{
                                    this.props.openModal(sanitizeBackendMessage(response.text_response) || "Ocurrió un error al consultar la factura, por favor intente más tarde", "info")
                                }
                                // this.props.openModal("No cuenta con facturas pendientes por pagar", "info");
                            }
                        }
                        this.setState({
                            loading: false
                        });
                    } else {
                        this.props.openModal(sanitizeBackendMessage(response.text_response) || "Ocurrió un error al consultar la factura, por favor intente más tarde", "warning");
                        this.setState({
                            loading: false
                        });
                    }
                }
            )
            .catch((error) => {
                handleIntegrationError(error, {
                    openModal: this.props.openModal,
                    flow: "consulta",
                    service: "recaudo-api",
                    endpoint: api.facturasApi,
                    setState: (updates) => this.setState(updates),
                    stateUpdates: { loading: false },
                    modalType: "warning",
                });
            });
    }

    validacionCampos(fieldType, fieldTypes) {
        // console.log(fieldType,fieldTypes)
        let validacion = ["required"];
        let type = fieldTypes && fieldTypes.length > 0 && fieldTypes.filter((field) => {
            return field.value === fieldType;
        });
        if ((fieldType === "text" || fieldType === "number" || fieldType === "textarea")) {
            if(type.length>0) validacion += `|min:2|max:${parseInt(type[0]["longitud"])}`;
        } else if (fieldType === "telephone") {
            validacion+="|numeric";
            if(type.length>0) validacion += `min:${parseInt(type[0]["min"])}|max:${parseInt(type[0]["max"])}`;
        } else if (fieldType === "checkbox") {
            validacion += `|array`;
        } else if (fieldType === "email") {
            validacion = ['required', {regex: '^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$'}];
        }
        return validacion;
    }

    onChangeDate(e) {
        let date = new Date(e);let fecha = `${date.getFullYear()}-${(date.getMonth() + 1) < 10 ? "0" : ""}${date.getMonth() + 1}-${date.getDate() < 10 ? "0" : ""}${date.getDate()} ${date.getHours() > 9 ? "" : "0"}${date.getHours()}:${date.getMinutes() > 9 ? "" : "0"}${date.getMinutes()}`;
        let configuracion = [...this.state.configuracion];
        let aux = null;
        let campo = configuracion.filter((conf, key) => {
            if (conf.fieldType === "date") {
                aux = key;
                return conf
            }
        });
        campo[0]["value"] = fecha;
        configuracion[aux] = campo[0];
        this.setState({
            configuracion
        })
    }

    handleDateChangeTime(e) {
        let date = new Date(e)
        let hora = `${date.getFullYear()}-${(date.getMonth() + 1) < 10 ? "0" : ""}${date.getMonth() + 1}-${date.getDate() < 10 ? "0" : ""}${date.getDate()} ${date.getHours() > 9 ? "" : "0"}${date.getHours()}:${date.getMinutes() > 9 ? "" : "0"}${date.getMinutes()}`;
        let configuracion = [...this.state.configuracion];
        let aux = null;
        let campo = configuracion.filter((conf, key) => {
            if (conf.fieldType === "time") {
                aux = key;
                return conf
            }
        });
        campo[0]["value"] = hora;
        configuracion[aux] = campo[0];
        this.setState({
            configuracion
        })
    }

    onChangeValor2(valor) {
        let configuracion = [...this.state.configuracion];
        let aux = null;
        let campo = configuracion.filter((conf, key) => {
            if (conf.fieldDb === "iva") {
                aux = key;
                return conf
            }
        });
        campo[0]["value"] = valor;
        if (valor !== "") {
            campo[0]["obligatory"] = true;
            this.forceUpdate();
        } else {
            campo[0]["obligatory"] = false;
            this.forceUpdate();
        }


        configuracion[aux] = campo[0];
        this.setState({
            configuracion
        })
    }

    onChangeValor(valor) {
        let configuracion = [...this.state.configuracion];
        let aux = null;
        let campo = configuracion.filter((conf, key) => {
            if (conf.fieldDb === "total") {
                aux = key;
                return conf
            }
        });
        campo[0]["value"] = valor;
        configuracion[aux] = campo[0];
        this.setState({
            configuracion
        })
    }

    render() {
        const {
            titulo,
            descripcion,
            configuracion,
        } = this.state;

        return (
            <Flex
                elastic={"1 0 auto"}
                flex={"1 0 auto"}
                className={"wc cambio"}
                css={css`animation:  ${Transition}  .8s cubic-bezier(0.075, 0.820, 0.165, 1.000) 1;`}
            >
                <Mycard
                    className={`col-12 ${configuracion.length > 3 ? "col-sm-12 col-md-10 col-lg-8" : "col-sm-8 col-md-6 col-lg-4"} mx-auto px-0`}
                    title={titulo}
                    titleClass="title_consulta"
                >
                    <div className="wc cg text-center description_consulta">
                        <p className={"mb-0 description_consulta"}><DescriptionComponent text={descripcion}/></p>
                    </div>
                    <form
                     className={"wc"}
                     onSubmit={e=>{
                        e.preventDefault();
                        if(this.props.rest_horarios.activo){
                            this.sendInfo();
                        }else{
                            this.modalRestHorarios();
                        }
                     }}
                    >
                        <div className={"wc f01 p-2 "}>
                        {
                            configuracion.map((conf, key) => {
                                return (

                                    <Campos
                                        key={key}
                                        conf={conf}
                                        i={key}
                                        onChange={this.onChange.bind(this)}
                                        onChangeRadio={this.onChangeRadioButton.bind(this)}
                                        onChangeCheckbox={this.onChangeCheckbox.bind(this)}
                                        onChangePrefijo={this.onChangePrefijo.bind(this)}
                                        onChangeDate={this.onChangeDate.bind(this)}
                                        onChangeValor={this.onChangeValor.bind(this)}
                                        onChangeValor2={this.onChangeValor2.bind(this)}
                                        campoDb={conf.fieldDb}
                                        disabled={this.state.loading}
                                        handleDateChangeTime={this.handleDateChangeTime.bind(this)}
                                        error={
                                            (conf.obligatory &&
                                                (this.validator.message(configuracion[key]["entity"], configuracion[key]["value"], this.validacionCampos(typeof conf.fieldType === "string" ? conf.fieldType : conf.fieldType[0].value, conf.fieldTypes)) !== undefined))

                                                ? this.validator.message(configuracion[key]["entity"], configuracion[key]["value"], this.validacionCampos(typeof conf.fieldType === "string" ? conf.fieldType : conf.fieldType[0].value, conf.fieldTypes))
                                                : ""
                                        }
                                    />

                                )
                            })
                        }
                    </div>
                    <div className={"wc f01 px-3 pt-3 indexFormularioBtn"}>
                        <Btn
                            disabled={this.state.loading}
                            type={"submit"}
                            loading={this.state.loading}
                        >
                            Consultar
                        </Btn>
                    </div>
                    
                    </form> 
                </Mycard>
                <Modal2
                    open={this.state.openModal}
                    close={() => this.setState({openModal: false})}
                    message={this.props.rest_horarios.message}
                    message2={this.props.rest_horarios.message2}
                    tipo={"info"}
                />
            </Flex>
        )
    }
}

export default InicioOnline;
